'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _toJS = require('./toJS');

var _toJS2 = _interopRequireDefault(_toJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * connect to store and parse the immutable object to literal
 * configs -> Presentation -> Container
* */
var connectToJS = function connectToJS() {
  for (var _len = arguments.length, configs = Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }

  return function (Component) {
    return _reactRedux.connect.apply(undefined, configs)((0, _toJS2.default)(Component));
  };
};

exports.default = connectToJS;